import { Injectable, inject } from "@angular/core";
import { AggregateActionResult, AggregateHelperService, IAggregateActionHandler } from "@tylertech/aggregates-module";
import { IAggregate, ICardData, ICardAction } from "@tylertech/tyler-api-types";

import { PurchasingDialogsService } from "../services";

@Injectable()
export class PurchaseOrderApprovalActionHandler implements IAggregateActionHandler
{
    private readonly $aggregateHelperService = inject(AggregateHelperService);
    private readonly purchasingDialogService = inject(PurchasingDialogsService);


    predicate(aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return aggregate.AggregateProviderId === "Purchasing.PurchaseOrderApproval" && action.Id === "Post";
    }

    execute(aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        const reqData = this.$aggregateHelperService.getFieldValue(cardData, "ReqDate");
        return this.purchasingDialogService.showPurchaseOrderApproval(new Date(reqData))
            .then((result: Date) =>
            {
                cardData.DataElements.push({
                    Label: "IssueDate",
                    Value: result.toDateString(),
                    Visible: false,
                    Type: null,
                    ActionItems: null,
                    Icon: null,
                });
                return this.$aggregateHelperService.performServerCardAction(aggregate, cardData, action);
            })
            .then((_result?: ICardData) =>
            {
                return true;
            });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
